import * as React from "react"

const MOBILE_QUERY = "(max-width: 767px)"

function getInitialMatch(query: string) {
  if (typeof window === "undefined") {
    return false
  }

  return window.matchMedia(query).matches
}

export function useMediaQuery(query: string) {
  const [matches, setMatches] = React.useState(() => getInitialMatch(query))

  React.useEffect(() => {
    if (typeof window === "undefined") {
      return
    }

    const mediaQuery = window.matchMedia(query)
    const listener = (event: MediaQueryListEvent) => {
      setMatches(event.matches)
    }

    setMatches(mediaQuery.matches)

    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", listener)
      return () => mediaQuery.removeEventListener("change", listener)
    }

    const legacyListener: MediaQueryListListener = (event) => listener(event as MediaQueryListEvent)
    mediaQuery.addListener(legacyListener)
    return () => mediaQuery.removeListener(legacyListener)
  }, [query])

  return matches
}

export function useIsMobile() {
  return useMediaQuery(MOBILE_QUERY)
}